import { useSelector } from "react-redux";

import {
    selectExcludeListsDuplicateOpportunitiesFetching,
    selectOpportunityListCreating,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";

import type { AddOpportunitiesToListDto, OpportunityListType } from "../../types";

import OpportunityListModalContainer from "./OpportunityListModalContainer";

interface IListModalWithDuplicateOpportunitiesParams {
    handleAddWebsitesToList: (list: Readonly<OpportunityListType>, dto: AddOpportunitiesToListDto) => void;
}
const ListModalWithDuplicateOpportunitiesContainer = ({
    handleAddWebsitesToList,
}: IListModalWithDuplicateOpportunitiesParams) => {
    const isListBeingCreated = useSelector(selectOpportunityListCreating);
    const isExcludeListsDataFetching = useSelector(selectExcludeListsDuplicateOpportunitiesFetching);

    return (
        <OpportunityListModalContainer
            isListDataLoading={isListBeingCreated || isExcludeListsDataFetching}
            onAddWebsites={handleAddWebsitesToList}
        />
    );
};

export default ListModalWithDuplicateOpportunitiesContainer;
